import { APP_NAME } from '@hub/libs/constants';
import React from 'react';
import { useTranslation } from 'next-i18next';

export const UploadProcessImages = ({ withNbs = false }: { withNbs?: boolean }) => {
  const { t } = useTranslation(['free-form-hub/freeFormHub']);

  const imageSection = (appName: string) => {
    return (
      <div className="flex flex-col items-center">
        <figure>
          <img src={`/_${APP_NAME}/images/ffh/${appName}.png`} alt="Injection Molding" />
        </figure>
        <h4 className="my-6 font-normal text-xxs">
          {t(`cus.upload-dialog.PROCESS_${appName.toUpperCase()}`, { ns: 'free-form-hub/freeFormHubUpload' })}
        </h4>
      </div>
    );
  };
  const imageSectionWithNbs = (index: number) => (
    <div className="w-1/3">
      <h4 className="my-4 text-igus-primary text-center text-xs  xl:text-md">
        {t(`cus.upload-dialog.PROCESS_${index.toString()}_TITLE`, { ns: 'free-form-hub/freeFormHubUpload' })}
      </h4>
      <p
        className="text-xxs xl:text-xs text-center"
        dangerouslySetInnerHTML={{
          __html: t(`cus.upload-dialog.PROCESS_${index}_DESCRIPTION`, {
            ns: 'free-form-hub/freeFormHubUpload',
          }),
        }}
      />
    </div>
  );

  return withNbs ? (
    <div className="flex flex-col mb-10">
      <div className="flex flex-col items-center">
        <figure className="w-full md:w-[500px]">
          <img src={`/_${APP_NAME}/images/ffh/steps.png`} alt="3D Printing" />
        </figure>
        <div className="flex flex-row">{[1, 2, 3].map(item => imageSectionWithNbs(item))}</div>
      </div>
    </div>
  ) : (
    <div className="flex flex-col gap-[30px]">
      <div className="flex flex-row justify-evenly ">{['idd', 'icn', 'imd'].map(item => imageSection(item))}</div>
    </div>
  );
};
